import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import * as _moment from 'moment';
import { DateTimeUtils } from '@blcloud/bl-common';
import { GridOptions } from 'ag-grid';
import {
  map as _map,
  isNil as _isNil,
  find as _find,
  cloneDeep as _cloneDeep,
  forEach as _forEach,
  delay as _delay,
  isEmpty as _isEmpty,
  isNumber as _isNumber,
} from 'lodash';
import {
  FunctionRef,
  FunctionRole,
  PageId,
  ScreenService,
  WithAllCompanyDiv,
  LoginResourceService,
  FileService,
  FnKey,
  SearchConditionPanelComponent,
} from '@blcloud/bl-ng-share-module';
import {
  AbstractContainer,
  BlReferenceGridComponent,
  ButtonCellRendererComponent,
  ButtonCellEditorComponent,
  BlModalService,
  ModalReason,
  BlFileData,
  BlDialogService,
  BlLoadingService,
  CheckboxCellEditorComponent,
  CheckboxCellRendererComponent,
  TooltipCellComponent,
} from '@blcloud/bl-ng-ui-component';
import { ProfileEntriesPageService } from './profile-entries-page.service';
import { combineLatest as ObservableCombineLatest } from 'rxjs/observable/combineLatest';
import { IDispProfileEntry, IDetailCondition } from './profile-entries-page.interface';
import {
  IOrganizationInformation,
  IFileManageInfo,
  IProfileEntry,
  ITicketIssue,
} from '@blcloud/bl-datamodel';
import { ProfileMatchingModalComponent } from './profile-matching-modal/profile-matching-modal.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { ReferenceTicketModalComponent } from './reference-ticket-modal/reference-ticket-modal.component';
import { BlUrlQuery, BlUrlQueryKey } from '@blcloud/bl-ng-common';
import { UrlUtils } from '@blcloud/bl-common';
import { PagePath } from '../../core/const/page-path.const';
import { CustomerInfoReflectStatusDiv } from '@blcloud/bl-datamodel/enum/customer/customer-info-reflect-status-div';

/**
 * プロフィール登録一覧画面
 */
@Component({
  selector: 'app-vcle-search-page',
  templateUrl: './profile-entries-page.component.html',
  styleUrls: ['./profile-entries-page.component.scss'],
  providers: [ProfileEntriesPageService],
})
export class ProfileEntriesPageComponent extends AbstractContainer implements OnInit, AfterViewInit {
  /** ページタイトル */
  title = 'お客様情報 承認待ち一覧';
  /** ページID */
  pageId = PageId.ProfileEntries;
  /** 組織情報表示区分 */
  WithAllCompanyDiv = WithAllCompanyDiv;
  /** 詳細抽出パネル */
  @ViewChild('conditionPanel') conditionPanel: SearchConditionPanelComponent;
  /**
   * Gridオプション
   * @ignore
   */
  gridOptions: GridOptions = {};

  /** 選択データ */
  private selectedData = null;

  /**
   * グリッド列定義情報作成
   */
  createColDef = [
    {
      headerName: '選択',
      field: 'select',
      width: 60,
      minWidth: 60,
      maxWidth: 60,
      editable: true,
      align: 'center',
      cellRendererFramework: CheckboxCellRendererComponent,
      cellEditorFramework: CheckboxCellEditorComponent,
      headerComponentFramework: CheckboxCellRendererComponent,
      headerComponentParams: {
        value: {
          label: '選択',
          checked: true,
          changeEvent: this.onChangeChkAll.bind(this),
        },
      },
      hide: false,
      pinned: true,
    },
    {
      headerName: '既存候補',
      field: 'link',
      minWidth: 150,
      cellStyle: { 'padding': '1px' },
      cellRendererFramework: ButtonCellRendererComponent,
      cellEditorFramework: ButtonCellEditorComponent,
      suppressSorting: true,
      hide: false,
      pinned: true,
    },
    {
      headerName: 'お客様情報登録日時',
      field: 'profileRegistDateTime',
      minWidth: 180,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '顧客車両反映日',
      field: 'dispCustomerInfoReflectDate',
      minWidth: 160,
      suppressSorting: true,
      hide: true,
    },
    {
      headerName: '顧客反映担当者',
      field: 'customerInfoReflectPicName',
      minWidth: 150,
      suppressSorting: true,
      hide: true,
    },
    {
      headerName: 'お客様名',
      field: 'customerName',
      minWidth: 150,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: 'お客様名カナ',
      field: 'customerNameKana',
      minWidth: 200,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '本人認証連絡先',
      field: 'useAuthContact',
      minWidth: 300,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '電話番号',
      field: 'contactInfoTel.contactInformation',
      minWidth: 120,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: 'メールアドレス',
      field: 'contactInfoEmail.contactInformation',
      minWidth: 300,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '郵便番号',
      field: 'postalCode',
      minWidth: 90,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '住所',
      field: 'address',
      minWidth: 300,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '性別',
      field: 'dispSexDiv',
      minWidth: 80,
      align: 'center',
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '生年月日',
      field: 'dispBirthDay',
      minWidth: 120,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: 'ナンバープレート',
      field: 'numberPlate',
      minWidth: 150,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: 'メーカー／車種',
      field: 'makerModel',
      minWidth: 200,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '車検満期日',
      field: 'dispVcleInspDueDate',
      minWidth: 120,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '車検証画像',
      field: 'image',
      minWidth: 150,
      cellStyle: { 'padding': '1px' },
      cellRendererFramework: ButtonCellRendererComponent,
      cellEditorFramework: ButtonCellEditorComponent,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: 'DM送信',
      field: 'dmSendDivEnumName',
      minWidth: 90,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '発行クーポン',
      field: 'ticket',
      minWidth: 150,
      cellStyle: { 'padding': '1px' },
      cellRendererFramework: ButtonCellRendererComponent,
      cellEditorFramework: ButtonCellEditorComponent,
      suppressSorting: true,
      hide: false,
    },
    {
      headerName: '申し送り事項',
      field: 'dispMessageNotices',
      minWidth: 300,
      suppressSorting: true,
      hide: false,
      cellRendererFramework: TooltipCellComponent,
    },
  ];
  /** グリッドのデータ */
  gridData = [];
  /** 検索結果件数 */
  resultCount = 0;
  /** 検索のイメージ */
  noRowsMessage: string;
  /** ページのtype */
  gridSizePatterns: number[] = [];
  /** 現在表示中ページ番号 */
  currentPageNumber = 1;

  /** 組織コード */
  organizationCode: string;
  /** 反映済み検索フラグ */
  reflectSearch = false;
  /** 詳細条件 */
  detailCondition: IDetailCondition = {};

  /**
   * 検索結果リストグリッド
   */
  @ViewChild('refGrid') refGrid: BlReferenceGridComponent;

  /** Grid初期化完了Emitter */
  private gridReadyEmitter: EventEmitter<boolean> = new EventEmitter();

  /** Grid更新Emitter */
  private gridUpdateEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private screenService: ScreenService,
    private service: ProfileEntriesPageService,
    private loginResourceService: LoginResourceService,
    private modalService: BlModalService,
    private fileService: FileService,
    private dialogService: BlDialogService,
    private loadingService: BlLoadingService,
  ) {
    super();
  }

  /**
   * @override
   */
  ngOnInit(): void {
    // ファンクション制御
    this.initFunctions();
    this.gridSizePatterns = [10];
    ObservableCombineLatest(
      this.gridReadyEmitter,
      this.gridUpdateEmitter,
    ).subscribe(
      response => {
        if (response[0] === true) {
          this.loginResourceService.getLoginUserEmployeeBindModel().subscribe(currentLoginUser => {
            this.organizationCode = currentLoginUser.organizationCode;
            this.updateGridData();
          });
        }
      }
    );
  }

  /**
   * @override
   */
  ngAfterViewInit(): void {
  }

  private initFunctions(pageId: PageId = PageId.ProfileEntries) {
    // 画面初期化(画面IDとファンクションを設定)
    this.screenService.initializeScreen(
      pageId,
      this.entriesFunctions,
      'お客様情報 登録一覧'
    ).subscribe(
      (functionRef) => {
        this.toOperations(functionRef);
      }
    );
    this.screenService.setLabelFnKey(FunctionRole.Next, '本登録');
    // 初期状態におけるファンクションの有効化
    this.screenService.enableFnKey([FunctionRole.Prev, FunctionRole.Toggle1Fn2]); // F2, F11
    // 初期状態におけるファンクションの無効化
    this.screenService.disableFnKey([
      FunctionRole.Next,
      FunctionRole.Toggle1Fn4,
      FunctionRole.CustomerReference,
      FunctionRole.EditCustomer,
      FunctionRole.EditVehicle,
    ]); // F12, F4, F3, F7, F8
  }

  /**
 * 各種ファンクションキー押下時の処理
 * @param ref 押下ファンクションキー
 */
  private toOperations(ref: FunctionRef) {
    switch (ref.role) {
      case FunctionRole.Toggle1Fn2: // F2
        // 反映済み検索フラグを変更する
        this.reflectSearch = !this.reflectSearch;
        this.currentPageNumber = 1;
        this.updateGridData();
        // 登録履歴を表示した場合は文言を変更し、チェックボックスとボタンを非表示にする
        if (this.reflectSearch) {
          this.title = 'お客様情報 履歴一覧';
          this.screenService.setFunctions(this.reflectFunctions).subscribe(
            (functionRef) => {
              this.toOperations(functionRef);
            }
          );
          this.createColDef[0].hide = true;
          this.createColDef[1].hide = true;
          this.createColDef[3].hide = false;
          this.createColDef[4].hide = false;
          this.refGrid.setColumnDefs(this.createColDef);
        } else {
          this.title = 'お客様情報 承認待ち一覧';
          this.screenService.setFunctions(this.entriesFunctions).subscribe(
            (functionRef) => {
              this.toOperations(functionRef);
            }
          );
          this.createColDef[0].hide = false;
          this.createColDef[1].hide = false;
          this.createColDef[3].hide = true;
          this.createColDef[4].hide = true;
          this.refGrid.setColumnDefs(this.createColDef);
        }
        this.screenService.setLabelFnKey(FunctionRole.Next, '本登録');
        ref.end();
        break;
      case FunctionRole.Toggle1Fn4: // F4
        this.service.isAvailableProfileMainEntryRole().subscribe(
          isAvailable => {
            if (!isAvailable) {
              this.dialogService.info('権限がないため破棄できません。').subscribe(
                modalInfo => {
                  modalInfo.hide();
                }
              );
            } else {
              this.dialogService.confirm('選択したお客様情報を破棄します。よろしいですか？').subscribe(
                modalRef => {
                  if (modalRef.reason === ModalReason.Done) {
                    this.loadingService.show();
                    const selectedRowData = this.getSelectedRowData();
                    const setData: IProfileEntry[] = [];
                    _forEach(selectedRowData, item => {
                      setData.push(item.holdProfileEntry);
                    });
                    this.service.multiplyDiscard(setData).pipe(
                      finalize(() => this.loadingService.hide())
                    ).subscribe(() => {
                      this.dialogService.info('破棄処理が完了しました。').subscribe(
                        modalInfo => {
                          modalInfo.hide();
                          this.currentPageNumber = 1;
                          this.updateGridData();
                        }
                      );
                    });
                  }
                  modalRef.hide();
                }
              );
            }
          }
        );
        ref.end();
        break;
      case FunctionRole.TopMenu: // F10
        ref.end();
        break;
      case FunctionRole.Prev: // F11
        ref.end();
        break;
      case FunctionRole.Next: // F12
        this.service.isAvailableProfileMainEntryRole().subscribe(
          isAvailable => {
            if (!isAvailable) {
              this.dialogService.info('権限がないため本登録できません。').subscribe(
                modalInfo => {
                  modalInfo.hide();
                }
              );
            } else {
              this.dialogService.confirm('選択したお客様情報を本登録します。よろしいですか？').subscribe(
                modalRef => {
                  if (modalRef.reason === ModalReason.Done) {
                    this.loadingService.show();
                    const selectedRowData = this.getSelectedRowData();
                    // タイムアウト対策で5件ずつ分ける。
                    const fstData = [];
                    const scdData = [];
                    _forEach(selectedRowData, rowData => {
                      if (fstData.length < 5) {
                        fstData.push(rowData);
                      } else {
                        scdData.push(rowData);
                      }
                    });
                    this.service.toMainEntry(fstData).subscribe(
                      () => {
                        // 1セット目が終わってから実行したいので入れ子にする
                        this.service.toMainEntry(scdData).subscribe(
                          () => {
                            this.loadingService.hide();
                            this.dialogService.info('本登録が完了しました。').subscribe(
                              modalInfo => {
                                modalInfo.hide();
                                this.currentPageNumber = 1;
                                this.updateGridData();
                              }
                            );
                          },
                          () => {
                            this.dialogService.warn('本登録に失敗したデータがあります。<br>少し時間をおいてから、再度お試し下さい。').subscribe(
                              modalInfo => {
                                modalInfo.hide();
                                this.currentPageNumber = 1;
                                this.updateGridData();
                              }
                            );
                          },
                        );
                      },
                      () => {
                        this.dialogService.warn('本登録に失敗したデータがあります。<br>少し時間をおいてから、再度お試し下さい。').subscribe(
                          modalInfo => {
                            modalInfo.hide();
                            this.currentPageNumber = 1;
                            this.updateGridData();
                          }
                        );
                      },
                    );
                  }
                  modalRef.hide();
                }
              );
            }
          }
        );
        ref.end();
        break;
      case FunctionRole.CustomerReference: // F3
        this.dialogService.confirm('お客様情報を反映した顧客の顧客照会画面を開きます。').subscribe(
          modalRef => {
            modalRef.hide();
            if (modalRef.reason === ModalReason.Done) {
              const urlQuery = new BlUrlQuery();
              urlQuery.setValue(BlUrlQueryKey.CustomerCode, this.selectedData.customerCode);
              if (this.selectedData.profileEntryVehicle.vehicleMgtNumber) {
                urlQuery.setValue(BlUrlQueryKey.VehicleMgtNumber, this.selectedData.profileEntryVehicle.vehicleMgtNumber);
              }
              window.open(
                UrlUtils.buildUrlPath(PagePath.CustomerInquiry, {
                  params: urlQuery.getQueryParams()
                }), '_blank');
            }
          }
        );
        ref.end();
        break;
      case FunctionRole.EditCustomer: // F7
        this.dialogService.confirm('お客様情報を反映した顧客の顧客入力画面を開きます。').subscribe(
          modalRef => {
            modalRef.hide();
            if (modalRef.reason === ModalReason.Done) {
              const urlQuery = new BlUrlQuery();
              if (this.selectedData.profileEntryVehicle.vehicleMgtNumber) {
                urlQuery.setValue(BlUrlQueryKey.VehicleMgtNumber, this.selectedData.profileEntryVehicle.vehicleMgtNumber);
              }
              window.open(
                UrlUtils.buildUrlPath(PagePath.CustomerEntry, {
                  id: this.selectedData.customerCode,
                  params: urlQuery.getQueryParams()
                }), '_blank');
            }
          }
        );
        ref.end();
        break;
      case FunctionRole.EditVehicle: // F8
        this.dialogService.confirm('お客様情報を反映した車両の車両入力画面を開きます。').subscribe(
          modalRef => {
            modalRef.hide();
            if (modalRef.reason === ModalReason.Done) {
              const urlQuery = new BlUrlQuery();
              urlQuery.setValue(BlUrlQueryKey.CustomerCode, this.selectedData.customerCode);
              window.open(
                UrlUtils.buildUrlPath(PagePath.VehicleEntry, {
                  id: this.selectedData.profileEntryVehicle.vehicleMgtNumber,
                  params: urlQuery.getQueryParams()
                }), '_blank');
            }
          }
        );
        ref.end();
        break;
      default:
        break;
    }
  }

  onReadyGrid(): void {
    this.gridReadyEmitter.emit(true);
    this.gridUpdateEmitter.emit(true);
    this.refGrid.enableSort();
    this.refGrid.setColumnDefs(this.createColDef);
  }

  /**
   * グリッドデータを更新します。
   */
  updateGridData() {
    // 見た目を一旦空にする
    this.gridOptions.api.setRowData([]);
    this.refGrid.setLoadingMessage('検索中...');
    this.screenService.disableFnKey([FunctionRole.Next, FunctionRole.Toggle1Fn4]); // F12
    this.refGrid.showLoading();
    this.loadingService.show();
    // 更新直後に再取得のパターンがあるのでElasticSearch反映を考慮し遅延させる
    _delay(() => {
      // データを取得
      this.service.getProfileEntries(
        this.organizationCode,
        this.currentPageNumber,
        this.reflectSearch,
        this.detailCondition,
      ).subscribe(
        results => {
          if (_isNil(results)) {
            this.refGrid.showNoRows();
            this.refGrid.setNoRowsMessage('該当する候補が見つかりません。');
            this.loadingService.hide();
            this.resultCount = 0;
            this.gridData = [];
            this.refGrid.gotoPage(this.currentPageNumber - 1);
            return;
          }
          const profileEntries = results.searchResultList;
          _map(profileEntries, (result, idx) => {
            result.dispMessageNotices = {
              value: result.messageNotices,
              tooltip: result.messageNotices,
              placement: 'bottom',
              tooltipClass: 'profile-entries-page-tooltip-inner',
            };
            result.select = {
              checked: false,
              value: idx + 1,
              changeEvent: this.suppressFn.bind(this),
              disabled: true,
            };
            result.image = {
              caption: '確認',
              classes: 'btn btn-default',
              onClick: this.onClickImageOpen.bind(this, result.profileEntryVehicle.vcleInspCertifImageFileMgt),
              // 画像の有無で活性を制御する
              disabled: _isNil(result.profileEntryVehicle.vcleInspCertifImageFileMgt) ? true : false,
            };
            result.link = {
              caption: '有り',
              classes: 'btn btn-default',
              onClick: this.onClickProfileMatching.bind(this, result),
              disabled: true,
            };
            result.ticket = {
              caption: '確認',
              classes: 'btn btn-default',
              onClick: this.onClickTicketOpen.bind(this, result.ticketIssueInfoList),
              // クーポンの有無で活性を制御する
              disabled: _isEmpty(result.ticketIssueInfoList) ? true : false,
            };
          });
          this.resultCount = results.totalCount;
          this.gridData = profileEntries;
          this.refGrid.setData(profileEntries);
          this.refGrid.hideOverlay();
          this.resizeGrid();
          this.refGrid.gotoPage(this.currentPageNumber - 1);
          // データを取得
          this.service.getCustomerVehicleLinkReq(profileEntries, this.reflectSearch).pipe(
            finalize(() => this.loadingService.hide())
          ).subscribe(
            linkResults => {
              // ボタンの制御を入れる
              _map(profileEntries, (result) => {
                // プロフィール登録情報に紐づく顧客をセットする
                const linkData = _find(
                  linkResults.profileEntryCustomerVehicleLinkOptList, item =>
                    item.profileRegistNum === result.profileRegistNum
                    && item.registerYearMonth === result.registerYearMonth
                );
                if (!_isNil(linkData) ) {
                  result.profileEntryCustomerVehicleLinkOptExistsFlag = linkData.profileEntryCustomerVehicleLinkOptExistsFlag;
                }
                // チェックボックスと既存候補有ボタンの活性
                if (result.profileEntryCustomerVehicleLinkOptExistsFlag) {
                  result.link.disabled = false;
                } else {
                  result.select.checked = true;
                  result.select.disabled = false;
                }
              });
              this.gridData = profileEntries;
              this.refGrid.setData(profileEntries);
              this.resizeGrid();
              this.refGrid.gotoPage(this.currentPageNumber - 1);
              this.suppressFn();
            }
          );
        }
      );
    }, 2000);
  }

  /**
   * Gridリサイズ
   */
  private resizeGrid() {
    this.gridOptions.columnApi.autoSizeAllColumns();
    // グリッド枠いっぱいに拡大
    this.gridOptions.api.sizeColumnsToFit();
  }

  /**
   * ページング： 前へボタンクリック時処理
   */
  onClickPrevPage(): void {
    this.currentPageNumber = this.currentPageNumber - 1;
    this.updateGridData();
  }

  /**
   * ページング： 次へボタンクリック時処理
   */
  onClickNextPage(): void {
    this.currentPageNumber = this.currentPageNumber + 1;
    this.updateGridData();
  }

  /**
   * 行選択時のイベント動作
   */
  onSelectedRow(e: any) {
    if (this.reflectSearch) {
      this.selectedData = e.data;
      if (this.selectedData.customerInfoReflectStatusDiv === CustomerInfoReflectStatusDiv.Reflected) {
        // 車両編集は車両がある場合のみ
        if (!_isNil(this.selectedData.profileEntryVehicle.vehicleMgtNumber)
          && this.selectedData.profileEntryVehicle.vehicleMgtNumber !== 0) {
          this.screenService.enableFnKey([FunctionRole.EditVehicle]);
        } else {
          this.screenService.disableFnKey([FunctionRole.EditVehicle]);
        }
        this.screenService.enableFnKey([
          FunctionRole.EditCustomer,
          FunctionRole.CustomerReference,
        ]);
      } else {
        this.screenService.disableFnKey([
          FunctionRole.EditCustomer,
          FunctionRole.EditVehicle,
          FunctionRole.CustomerReference
        ]);
      }
    } else {
      this.selectedData = null;
      this.screenService.disableFnKey([
        FunctionRole.CustomerReference,
        FunctionRole.EditCustomer,
        FunctionRole.EditVehicle,
      ]); // F3, F7, F8
    }
  }

  /**
   * 管理組織情報の値変更処理
   *
   * @param value 変更値
   */
  onChangeOrgCode(value: IOrganizationInformation): void {
    this.organizationCode = value.organizationCode;
    this.currentPageNumber = 1;
    this.updateGridData();
  }

  /**
   * 日付範囲の相関チェックを行います。
   * @param start 開始日
   * @param end 終了日
   * @returns エラーメッセージ
   */
  private validateDateRange(start: string | number, end: string | number): string {

    const startDate = _isNumber(start) ? DateTimeUtils.formatIso(start) : start;
    const endDate = _isNumber(end) ? DateTimeUtils.formatIso(end) : end;

    // 開始日 < 終了日であるか
    if (_moment(startDate).isAfter(_moment(endDate))) {
      return '期間が不正です。入力内容を確認してください。';
    }

    return null;
  }

  /**
   * 条件取消処理
   *
   */
  onClear(): void {
    this.detailCondition = {
      customerNameKana1: null,
      contactInfoTel: null,
      numPlateSeriesSpecifNum: null,
      contactInfoEmail: null,
      useAuthContact: null,
      profileRegistDateTimeStart: null,
      profileRegistDateTimeEnd: null,
    };
    this.currentPageNumber = 1;
    this.updateGridData();
    this.conditionPanel.hide();
  }

  /**
   * 詳細検索処理
   *
   */
  onSearch(): void {
    const error = this.validateDateRange(this.detailCondition.profileRegistDateTimeStart, this.detailCondition.profileRegistDateTimeEnd);
    if (!_isNil(error)) {
      this.dialogService.warn(error).subscribe(
        dialogRef => {
          dialogRef.hide();
        }
      );
    } else {
      this.currentPageNumber = 1;
      this.updateGridData();
      this.conditionPanel.hide();
    }
  }

  /**
   * チェックボックス押下によるファンクションキーの制御を実行します。
   */
  suppressFn() {
    // 登録履歴は本登録不可
    if (this.reflectSearch) {
      this.screenService.disableFnKey([FunctionRole.Next, FunctionRole.Toggle1Fn4]);
      return;
    }
    const selectedRowData = this.getSelectedRowData();
    // グリッド行を選択していない時は本登録ファンクションを非活性にする。
    if (selectedRowData.length === 0) {
      this.screenService.disableFnKey([FunctionRole.Next, FunctionRole.Toggle1Fn4]);
    } else {
      this.screenService.enableFnKey([FunctionRole.Next, FunctionRole.Toggle1Fn4]);
    }
  }

  /**
   * チェックボックス全押下オプション
   */
  private onChangeChkAll() {
    // ヘッダーのチェック状態を更新する
    const headerCell = this.refGrid.columnDefs.find((d) => {
      return d.field === 'select';
    });
    const isChecked = !headerCell.headerComponentParams.value.checked;
    headerCell.headerComponentParams.value.checked = isChecked;
    // 各行のチェック状態を更新する
    this.refGrid.gridOptions.api.forEachNode((node) => {
      if (!node.data['select'].disabled) {
        node.data['select'].checked = isChecked;
      }
    });
    this.refGrid.gridOptions.api.redrawRows(); // 再描画が必要
    this.suppressFn();
  }

  /**
   * チェックボックスが選択状態になっているグリッドデータを取得します。
   */
  getSelectedRowData(): IDispProfileEntry[] {
    const checked = this.gridData.filter(d => !!d.select.checked);
    return checked;
  }

  /**
   * 車検証画像確認ボタン押下処理
   * @param fileManageInfo 画像データ
   */
  private onClickImageOpen(fileManageInfo: IFileManageInfo) {
    if (_isNil(fileManageInfo)) {
      return;
    }
    // 二重起動防止用loading
    this.loadingService.show();
    this.fileService.download(fileManageInfo).subscribe(file => {
      this.readfiles(file).subscribe(result => {
        this.loadingService.hide();
        this.modalService.show(ImageModalComponent, { data: { src: [result.data] } }).subscribe(
          modalRef => {
            modalRef.hide();
          }
        );
      });
    });
  }

  /**
   * ファイル読み込み処理
   * @param file ファイル
   * @returns ファイルデータ
   */
  private readfiles(file: File): Observable<BlFileData> {

    return new Observable(observer => {
      const fileData = new BlFileData(file);
      const reader = new FileReader();
      reader.onload = () => {
        fileData.data = reader.result;
        observer.next(fileData);
        observer.complete();
      };
      reader.readAsDataURL(file);
    });
  }

  /**
   * 既存候補有りボタン押下処理
   * @param selectData 選択行データ
   */
  private onClickProfileMatching(selectData: IDispProfileEntry) {
    this.loadingService.show();
    // データを取得
    this.service.getProfileMatching(selectData).pipe(
      finalize(() => this.loadingService.hide())
    ).subscribe(
      linkResult => {
        this.modalService.show(ProfileMatchingModalComponent,
          {
            data: {
              profileEntry: selectData,
              profileEntryVehicle: selectData.profileEntryVehicle,
              profileEntryCustomerVehicleLinkOptDtlList: _cloneDeep(linkResult.profileEntryCustomerVehicleLinkOptDtlList),
            }
          }
        ).subscribe(
          modalRef => {
            modalRef.hide();
            if (modalRef.reason === ModalReason.Done || modalRef.reason === ModalReason.Any) {
              this.currentPageNumber = 1;
              this.updateGridData();
            }
          }
        );
      }
    );
  }

  /**
   * クーポン確認ボタン押下処理
   * @param fileManageInfo 画像データ
   */
  private onClickTicketOpen(ticketIssueInfoList: ITicketIssue[]) {
    if (_isEmpty(ticketIssueInfoList)) {
      return;
    }
    this.modalService.show(ReferenceTicketModalComponent, { data: { ticketIssue: ticketIssueInfoList } }).subscribe(
      modalRef => {
        modalRef.hide();
      }
    );
  }

  /** 承認待ちFunction一覧 */
  get entriesFunctions(): any[][] {
    return [[
      FnKey.Toggle1Fn2.setLabel('登録履歴'), // F2
      FnKey.Toggle1Fn4.setLabel('破棄'), // F4
    ]];
  }

  /** 反映済みFunction一覧 */
  get reflectFunctions(): any[][] {
    return [[
      FnKey.Toggle1Fn2.setLabel('承認待ち一覧'), // F2
      FnKey.CustomerReference, // F3
      FnKey.EditCustomer, // F7
      FnKey.EditVehicle, // F8
    ]];
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-entries-page.component.ts